import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import AutoSaveTextField from '../../../../../../../../common/components/AutoSaveTextField';

const DiscardedPiecesInputComponent = ({ value, scrapId, disabled, handleUpdate }) => {
    const { t } = useTranslation();

    const handleBlur = event => {
        const newValue = +event.target.value;

        if (value !== newValue) {
            handleUpdate(
                `scraps.$[scrapId]`,
                {
                    scrap: { discardedPieces: newValue },
                },
                'update',
                { scrapId }
            );
        }
    };

    return (
        <AutoSaveTextField
            onlyPositiveDigits
            type="number"
            value={value}
            disabled={disabled}
            label={t('ncrInfo.immediate.discardedPiecesInputLabel')}
            onBlur={handleBlur}
            onKeyPress={event => {
                event.key === 'Enter' && handleBlur(event);
            }}
            fullWidth
        />
    );
};

const DiscardedPiecesInput = memo(DiscardedPiecesInputComponent);

export default DiscardedPiecesInput;
